import { createStore } from 'vuex'

import router from '@/router'
import {  getLoginUserInfo, getRecodes, makeRecords } from '@/views/js'
import cookies from 'vue-cookies'
import { nextTick } from 'vue'
import { toGetAIConfig } from '@/untils/company'
import { toGetApp } from '@/untils/knowledege'


export default createStore({
  state: {
    foldUp: cookies.get('foldUp')||true,
    token: localStorage.getItem('pctoken'),
    mobile: cookies.get('mobile'),
    INTSort: cookies.get('INTSort'),
    company: cookies.get('company'),
    companyList: null,
    fontSize: localStorage.getItem('fontSize'),
    reloadFlag: false,
    reloadINTFlag: false,
    reloadFavorFlag: false,
    taskList: [],
    INTSortChange: cookies.get('INTSortChange'),
    clientId: cookies.get('clientId'),
    avatar: cookies.get('avatar'),
    appList:[],
    subsribePage: cookies.get('subsribePage'),
    AIConfig:{webSearch:false,articleChat:false,reportLibrary:false},
    knowledgeAPPList:[]
  },
  getters: {
    fontSize(state) {
      return state.fontSize
    },
    subsribePage(state) {
      return state.subsribePage
    },
    mobile(state) {
      return state.mobile
    },
    company(state) {
      return state.company
    },
    INTSort(state) {
      return state.INTSort
    },
    companyList(state) {
      return state.companyList
    },
    reloadFlag(state) {
      return state.reloadFlag
    },
    reloadINTFlag(state) {
      return state.reloadINTFlag
    },
    reloadFavorFlag(state) {
      return state.reloadFavorFlag
    },
    taskList(state) {
      return state.taskList
    },
    INTSortChange(state) {
      return state.INTSortChange
    },
    clientId(state) {
      return state.clientId
    },
    avatar(state) {
      return state.avatar
    },
    appList(state) {
      return state.appList
    },
    foldUp(state) {
      var foldUp =true
    
     if(state.foldUp=='true'){
        foldUp = true
      }
      else if (state.foldUp=='false'){
        foldUp = false
      }
      else {
        foldUp = state.foldUp
      }
      state.foldUp = foldUp
      cookies.set('foldUp',foldUp)
    
      return  foldUp
     
    },
    AIConfig(state){
      return  state.AIConfig
    },
     knowledgeAPPList (state){
   
   
      return state.knowledgeAPPList
    }
  },
  mutations: {
    SET_reloadFlag: (state, reloadFlag) => {
      state.reloadFlag = reloadFlag
    },
    SET_reloadINTFlag: (state, reloadINTFlag) => {
      state.reloadINTFlag = reloadINTFlag
    },
    SET_reloadFavorFlag: (state, reloadFavorFlag) => {
      state.reloadFavorFlag = reloadFavorFlag
    },
    SET_companyList: (state, companyList) => {


      state.companyList = companyList
    },
    SET_token: (state, token) => {
      state.token = token

      localStorage.setItem('pctoken', token)

    },
    SET_INTSort: (state, INTSort) => {
      var list = []
      for (var i in INTSort) {
        list.push({ id: INTSort[i].id, name: INTSort[i].name })
      }
      state.INTSort = list


      cookies.set('INTSort', list)
    },
    SET_company: (state, company) => {
      state.company = company
      console.log(company, 'SET_company')
   
      cookies.set('company', company)
    },
    SET_subsribePage: (state, subsribePage) => {
      state.subsribePage = subsribePage
      cookies.set('subsribePage', subsribePage)
    },
    SET_fontSize: (state, fontSize) => {
      state.fontSize = fontSize
      localStorage.setItem('fontSize', fontSize)
    },
    SET_TASKLIST: (state, taskList) => {
   
      state.taskList = taskList
   
    },
    SET_mobile: (state, mobile) => {
      state.mobile = mobile

      cookies.set('mobile', mobile)
    },
    SET_avatar: (state, avatar) => {
      state.avatar = avatar

      cookies.set('avatar', avatar)
    },
    SET_INTSORTCHANGE: (state, INTSortChange) => {
      state.INTSortChange = INTSortChange

      cookies.set('INTSortChange', INTSortChange)
    },
    SET_clientId: (state, clientId) => {
      state.clientId = clientId

      cookies.set('clientId', clientId)
    },
    SET_appList: (state, appList) => {
      state.appList = appList
    },
    SET_foldUp: (state, foldUp) => {
      state.foldUp = foldUp
      cookies.set('foldUp', foldUp)
    },
    SET_AIConfig: (state, AIConfig) => {
      state.AIConfig = AIConfig
    },
    SET_knowledgeAPPList: (state, knowledgeAPPList) => {
      state.knowledgeAPPList = knowledgeAPPList
    }
  },
  actions: {
    mobile({ commit }, mobile) {
      if (this.state.mobile == null || this.state.mobile == '') {
        console.log('mobile')
        getLoginUserInfo().then((res) => {
          var mobile = res.data.sysClient.mobile
          commit('SET_mobile', mobile)
        })
      }

    },
    avatar({ commit }, mobile) {
      if (this.state.avatar == null || this.state.avatar == '') {
        console.log('avatar')
        getLoginUserInfo().then((res) => {
          var avatar = res.data.sysClient.picUrl

          commit('SET_avatar', avatar)
        })
      }

    },
    clientId({ commit }, mobile) {
      if (this.state.clientId == null || this.state.clientId == '') {
        console.log('clientId')
        getLoginUserInfo().then((res) => {
          var clientId = res.data.sysClient.id
          commit('SET_clientId', clientId)
        })
      }

    },
    exitAccount({ commit }, token) {

      commit('SET_companyList', null)
      localStorage.removeItem('pctoken')
      cookies.remove('avatar')
      cookies.remove('company')
      cookies.remove('INTSort')
      cookies.remove('mobile')
      cookies.remove('clientId')
      cookies.remove('foldUp')
      router.push({ path: '/' })
      window.location.reload()
    },
    token({ commit, dispatch }, token) {
      commit('SET_token', token)

      return new Promise((resolve, reject) => {

        getLoginUserInfo().then(async (res) => {
          console.log('token')
          var company = res.data.sysClient.companyVos
          var loginName = res.data.sysClient.loginName
          var mobile = res.data.sysClient.mobile
          var avatar = res.data.sysClient.picUrl
          var clientId = res.data.sysClient.id
          commit('SET_companyList', company)
          console.log({ company: company, loginName: loginName })

          commit('SET_mobile', mobile)
          commit('SET_fontSize', 2)
          commit('SET_avatar', avatar)
          commit('SET_clientId', clientId)
          await dispatch("toGetRecodes", { company: company, loginName: loginName, turn: true })
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })

    },
    toReturn({ state }) {
      console.log(state.companyList, state.company, 'toReturn')
      nextTick(() => {

        var href = window.location.href
        if (href.indexOf('http://qb.cbio.vip:81') > -1) {
          window.location.href = 'http://qb.cbio.vip:81'
        }
        else if (href.indexOf('http://10.0.0.103:8080') == 0) {
          window.location.href = 'http://10.0.0.103:8080'
        }
        else {
          window.location.href = 'http://qb.cbio.vip'
        }
        router.replace({ name: 'mainPage' })
      })
    },
    toGetUserfor({ commit, dispatch, state }) {

      return new Promise((resolve, reject) => {
        getLoginUserInfo().then(async (res) => {
          console.log('toGetUserfor')
          var company = res.data.sysClient.companyVos
          var loginName = res.data.sysClient.loginName
          commit('SET_clientId', res.data.sysClient.id)
          if (company) {
            console.log(company, 'toGetUserforcompany')
            commit('SET_companyList', company)
            commit('SET_fontSize', 2)
            var result = state.company && state.company.companyId ? company.find(item => item.companyId == state.company.companyId) : null
            console.log(state.company, company)
            if (result == null)
              await dispatch("toGetRecodes", { company: company, loginName: loginName })

          }
          else dispatch('exitAccount', null)


          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })

    },
    toGetUserforCompanyList({ commit }) {
      return new Promise((resolve, reject) => {
        getLoginUserInfo().then(async (res) => {
          console.log('toGetUserforCompanyList')
          commit('SET_clientId', res.data.sysClient.id)
          var company = res.data.sysClient.companyVos

          if (company) {
            console.log(company, 'company')
            commit('SET_companyList', company)


          }



          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    toGetRecodes({ commit, dispatch }, params) {

      new Promise(async (resolve, reject) => {
        await getRecodes().then((res) => {
          console.log(params, 'result', res)
          var company = params.company
          var loginName = params.loginName

          var result = res.data && res.data.companyId ? company.find(item => item.companyId == res.data.companyId) : null

          if (result)
            commit('SET_company', { companyId: result.companyId, companyName: result.companyName, loginName: loginName, manager: result.manager, companyType: result.companyType, vip: result.vip, 
          payStatus: result.payStatus,todayImg: result.todayImg,todayHomepageImg: result.todayHomepageImg
            })
          else {
            result = company[0]
            commit('SET_company', { companyId: result.companyId, companyName: result.companyName, loginName: loginName, manager: result.manager, companyType: result.companyType, vip: result.vip, 
              payStatus: result.payStatus,todayImg: result.todayImg,todayHomepageImg: result.todayHomepageImg
            })

          }
          nextTick(() => {
            if (params.turn == true)
              dispatch('toReturn')
            resolve()
          })


        }).catch((error) => {
          reject(error)
        })
      })


    },
    reloadFlag({ commit }, reloadFlag) {
      commit('SET_reloadFlag', reloadFlag)
    },
    reloadINTFlag({ commit }, reloadINTFlag) {
      commit('SET_reloadINTFlag', reloadINTFlag)
    },
    reloadFavorFlag({ commit }, reloadFavorFlag) {
      commit('SET_reloadFavorFlag', reloadFavorFlag)
    },
    companyList({ commit }, companyList) {
      commit('SET_companyList', companyList)
    },
    INTSort({ commit }, INTSort) {
      commit('SET_INTSort', INTSort)
    },
    company({ commit }, company) {
      commit('SET_company', company)
    },
    fontSize({ commit }, fontSize) {
      commit('SET_fontSize', fontSize)
    },
    taskList({ commit, state }, taskList) {
      var list = state.taskList.toString().split(',')
      list = list.filter(item => item != '')
      list.push(taskList)
      commit('SET_TASKLIST', list)
    },
    taskListReset({ commit }, taskList) {
      commit('SET_TASKLIST', taskList)
    },
    INTSortChange({ commit }, INTSortChange) {
      commit('SET_INTSORTCHANGE', INTSortChange)
    },
    changeCompany({ commit, state, dispatch }, params) {
      if (state.companyList) {
        var result = state.companyList.find(item => item.companyId == params)
        console.log(result, 'result')
        if (result) {
          commit('SET_company', { companyId: result.companyId, companyName: result.companyName, loginName: state.company.loginName, manager: result.manager, companyType: result.companyType, vip: result.vip, payStatus: result.payStatus,
            todayImg: result.todayImg,todayHomepageImg: result.todayHomepageImg })
          commit('SET_INTSort', null)
          makeRecords({ companyId: result.companyId, labelId: 0 }).then((res) => {
       
            router.replace({ name: 'mainPage' })
          
            
           
          })
        }
        //dispatch("toReturn")

      }

    },
    appList({ commit }, appList) {
      commit('SET_appList', appList)

    },
    foldUp({ commit,state }, foldUp) {
     
      commit('SET_foldUp', !state.foldUp)
      
    },
    AIConfig({ commit,state }, AIConfig) {
     
      commit('SET_AIConfig', AIConfig)
      
    },
    knowledgeAPPList({ commit,state }, knowledgeAPPList) {
     
      commit('SET_knowledgeAPPList', knowledgeAPPList)
      
    },
      
  },
  modules: {
  }
})
